/**
 * @fileoverview gRPC-Web generated client stub for core.private.companyintegrations
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


import * as grpcWeb from "grpc-web";


import {
  GetCompanyIntegrationsRequest,
  GetCompanyIntegrationsResponse} from "./companyintegrations_pb";

export class CompanyIntegrationServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options["format"] = "text";

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetCompanyIntegrations = new grpcWeb.AbstractClientBase.MethodInfo(
    GetCompanyIntegrationsResponse,
    (request: GetCompanyIntegrationsRequest) => {
      return request.serializeBinary();
    },
    GetCompanyIntegrationsResponse.deserializeBinary
  );

  getCompanyIntegrations(
    request: GetCompanyIntegrationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetCompanyIntegrationsResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/core.private.companyintegrations.CompanyIntegrationService/GetCompanyIntegrations",
      request,
      metadata || {},
      this.methodInfoGetCompanyIntegrations,
      callback);
  }

}

